/* fh-pdp.js — PDP controller. Replaces the mockup's DCLogic state with real Shopify variant + cart behavior.
   Handles: size→variant (price/label/active/trio/stock), qty, gallery swap, add-to-bag (AJAX + toast + cart count),
   accordions (single-open per group). Vanilla, defensive, reduced-motion aware. */
(function () {
  var root = document.querySelector('[data-fh-pdp]');

  /* ---------- size / variant ---------- */
  function money(el) { return el; }
  if (root) {
    var sizeBtns = [].slice.call(root.querySelectorAll('[data-fh-size]'));
    var varInput = root.querySelector('[data-fh-varid]');
    var priceEls = [].slice.call(root.querySelectorAll('[data-fh-price]'));
    var sizeLabel = root.querySelector('[data-fh-sizelabel]');
    var trio = root.querySelector('[data-fh-trio]');
    var addBtn = root.querySelector('[data-fh-add]');
    var stock = root.querySelector('[data-fh-stock]');
    // diwali-1010:pdp-sleeve. A gift set's Diwali sleeve tick (set pages only, while the festive switch is on) adds the
    // line property to both buttons below, because Buy it now goes straight to GoKwik and never shows the bag.
    function fhSleeveLine(body) {
      var t = root.querySelector('[data-fh-sleeve-opt][aria-pressed="true"]');
      if (t) { body.properties = {}; body.properties[t.getAttribute('data-fh-sleeve-prop') || 'Diwali Sleeve'] = 'Yes'; }
      return body;
    }

    function selectSize(btn) {
      // polish-1020:oos (Kriti, via Anirudh 20 Oct): a sold-out size stays greyed out, picked or not
      sizeBtns.forEach(function (b) {
        var on = b === btn, ok = b.getAttribute('data-avail') === 'true';
        b.style.borderColor = on ? 'var(--fh-ink)' : (ok ? 'rgba(0,0,0,.18)' : 'rgba(0,0,0,.08)');
        b.style.background = on && ok ? 'var(--fh-ink)' : (ok ? '#fff' : '#F6F5F2');
        b.style.color = on && ok ? '#fff' : (ok ? 'var(--fh-ink)' : 'rgba(12,12,12,.38)');
        b.style.cursor = ok ? 'pointer' : 'not-allowed';
        var sub = b.querySelector('.fh-size-sub');
        if (sub) sub.style.color = on && ok ? 'rgba(255,255,255,.7)' : (ok ? '#6a6a6a' : 'rgba(12,12,12,.42)');
      });
      var id = btn.getAttribute('data-variant-id');
      var price = btn.getAttribute('data-price');
      var ml = btn.getAttribute('data-ml');
      var avail = btn.getAttribute('data-avail') === 'true';
      if (varInput && id) varInput.value = id;
      priceEls.forEach(function (p) { if (price) p.innerHTML = (p.hasAttribute('data-fh-add-label') ? 'Add to bag · ' : '') + price; });
      if (addBtn) {
        // label comes from the section setting (data-add-label); no price on the button since 2026-07-24
        var lbl = avail ? (addBtn.getAttribute('data-add-label') || 'Add to bag') : 'Sold out';
        addBtn.innerHTML = lbl;
        addBtn.disabled = !avail;
        addBtn.style.opacity = avail ? '1' : '.5';
        addBtn.style.cursor = avail ? 'pointer' : 'not-allowed';
      }
      // buy-now is the dark primary now, so it must not sit there black and dead on a sold-out size
      var bnBtn = root.querySelector('[data-fh-buynow]');
      if (bnBtn) bnBtn.style.display = avail ? '' : 'none';
      if (sizeLabel) sizeLabel.textContent = ml;
      if (trio) trio.style.display = (ml && ml.toLowerCase().replace(/\s/g, '') === '10ml') ? 'flex' : 'none';
      if (stock) stock.style.display = avail ? 'flex' : 'none';
    }
    sizeBtns.forEach(function (b) { b.addEventListener('click', function () { if (b.getAttribute('data-avail') !== 'true') return; selectSize(b); }); }); // polish-1020:oos: a sold-out size is not picked
    // init trio state on load (in case first variant is 10ml)
    var initSel = root.querySelector('[data-fh-size][data-variant-id="' + (varInput && varInput.value) + '"]');
    if (initSel) selectSize(initSel);

    /* ---------- qty ---------- */
    var qty = root.querySelector('[data-fh-qty]');
    var dec = root.querySelector('[data-fh-qtydec]');
    var inc = root.querySelector('[data-fh-qtyinc]');
    function setQty(n) { if (qty) qty.value = Math.max(1, Math.min(99, n)); }
    if (dec) dec.addEventListener('click', function () { setQty(parseInt(qty.value || '1', 10) - 1); });
    if (inc) inc.addEventListener('click', function () { setQty(parseInt(qty.value || '1', 10) + 1); });
    if (qty) qty.addEventListener('change', function () { setQty(parseInt(qty.value, 10) || 1); }); // typed blank / 0 / letters never reach the cart

    /* ---------- gallery (click thumbs + swipe main) ---------- */
    var main = root.querySelector('[data-fh-main]');
    var stage = root.querySelector('[data-fh-stage]') || (main && main.parentElement);
    var thumbs = [].slice.call(root.querySelectorAll('[data-fh-thumb]'));
    var galIndex = 0;
    if (main) main.style.transition = 'opacity .22s ease';
    function showIndex(i) {
      if (i < 0) i = 0; if (i > thumbs.length - 1) i = thumbs.length - 1;
      galIndex = i;
      var t = thumbs[i]; if (!t) return;
      var full = t.getAttribute('data-full');
      if (main && full) { main.style.opacity = '0'; setTimeout(function () { main.src = full; main.style.opacity = '1'; }, 150); }
      thumbs.forEach(function (o) { o.style.borderColor = 'rgba(0,0,0,.12)'; o.style.opacity = '.7'; });
      t.style.borderColor = 'var(--fh-ink)'; t.style.opacity = '1';
    }
    thumbs.forEach(function (t, idx) { t.addEventListener('click', function () { showIndex(idx); }); });
    // touch/pointer swipe on the main stage — the place users most expect it
    if (stage && thumbs.length > 1) {
      var sx = 0, sy = 0, tracking = false;
      stage.style.touchAction = 'pan-y';
      stage.addEventListener('touchstart', function (e) { var t = e.changedTouches[0]; sx = t.clientX; sy = t.clientY; tracking = true; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (!tracking) return; tracking = false;
        var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) showIndex(dx < 0 ? galIndex + 1 : galIndex - 1);
      }, { passive: true });
      // pointer (trackpad/mouse drag) parity
      stage.addEventListener('pointerdown', function (e) { if (e.pointerType === 'touch') return; sx = e.clientX; sy = e.clientY; tracking = true; });
      stage.addEventListener('pointerup', function (e) {
        if (!tracking || e.pointerType === 'touch') return; tracking = false;
        var dx = e.clientX - sx, dy = e.clientY - sy;
        if (Math.abs(dx) > 44 && Math.abs(dx) > Math.abs(dy)) showIndex(dx < 0 ? galIndex + 1 : galIndex - 1);
      });
    }

    /* ---------- open the mini-cart drawer (refresh its contents, then open) ---------- */
    function openCartDrawer() {
      var d = document.querySelector('cart-drawer'); if (!d) return false;
      var done = function () { if (typeof d.open === 'function') { try { d.open(); } catch (e) {} } };
      fetch('/?sections=cart-drawer').then(function (r) { return r.json(); }).then(function (data) {
        var html = data && data['cart-drawer'];
        if (html) { var tmp = document.createElement('div'); tmp.innerHTML = html; var fresh = tmp.querySelector('cart-drawer'); if (fresh) { d.innerHTML = fresh.innerHTML; if (fresh.className) d.className = fresh.className; } }
        done();
      }).catch(done);
      return true;
    }

    /* ---------- buy it now (add + go to checkout) ---------- */
    var buyNow = root.querySelector('[data-fh-buynow]');
    if (buyNow) {
      buyNow.addEventListener('click', function () {
        if (addBtn && addBtn.disabled) return;
        var id = varInput ? varInput.value : null;
        var q = qty ? parseInt(qty.value || '1', 10) : 1;
        var orig = buyNow.innerHTML;
        buyNow.innerHTML = 'Taking you to checkout…';
        fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(fhSleeveLine({ id: id, quantity: q }))
        }).then(function () {
          // Route through the GoKwik checkout modal instead of the native /checkout, with a native fallback.
          if (typeof window.fhGokwikCheckout === 'function') {
            return window.fhGokwikCheckout().then(function (ok) { if (ok) { buyNow.innerHTML = orig; } else { window.location.href = '/checkout'; } });
          }
          window.location.href = '/checkout';
        }).catch(function () { buyNow.innerHTML = orig; toast('Could not start checkout'); });
      });
    }

    /* ---------- add to bag (AJAX + toast + cart count) ---------- */
    var form = root.querySelector('form[action*="/cart/add"]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (addBtn && addBtn.disabled) return;
        var id = varInput ? varInput.value : null;
        var q = qty ? parseInt(qty.value || '1', 10) : 1;
        var orig = addBtn ? addBtn.innerHTML : '';
        if (addBtn) { addBtn.innerHTML = 'Adding…'; addBtn.disabled = true; }
        fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(fhSleeveLine({ id: id, quantity: q }))
        }).then(function (r) { return r.json(); }).then(function (item) {
          if (addBtn) { addBtn.innerHTML = orig; addBtn.disabled = false; }
          return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            document.querySelectorAll('[data-fh-cartcount], .cart-count, .cart-count-bubble, [data-cart-count]').forEach(function (el) {
              el.textContent = cart.item_count;
            });
            document.dispatchEvent(new CustomEvent('fh:cart:added', { detail: cart }));
            // open the mini-cart drawer (the "cart popup"); fall back to a toast if the drawer is absent
            if (!openCartDrawer()) toast('Added to bag · ' + (item.product_title || '') + ' ' + (item.variant_title || ''));
          });
        }).catch(function () {
          if (addBtn) { addBtn.innerHTML = orig; addBtn.disabled = false; }
          toast('Could not add to bag');
        });
      });
    }
  }

  var _tt;
  function toast(msg) {
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    var existing = document.querySelector('[data-fh-toast]');
    if (existing) existing.remove();
    var t = document.createElement('div');
    t.setAttribute('data-fh-toast', '');
    t.setAttribute('role', 'status');
    t.setAttribute('aria-live', 'polite');
    t.style.cssText = 'position:fixed;left:50%;bottom:30px;transform:translateX(-50%);z-index:100;background:#0c0c0c;color:#fff;border-radius:8px;padding:15px 26px;font-family:Roboto,system-ui,sans-serif;font-size:13px;font-weight:600;letter-spacing:.04em;box-shadow:0 12px 40px rgba(0,0,0,.28);display:flex;align-items:center;gap:10px;' + (reduce ? '' : 'animation:fhToast 2.4s ease forwards;');
    t.innerHTML = '<span style="color:#E8442A">✓</span> ' + msg;
    document.body.appendChild(t);
    clearTimeout(_tt);
    _tt = setTimeout(function () { if (t.parentNode) t.remove(); }, 2500);
  }

  /* ---------- video: autoplay muted loop + click-to-unmute ---------- */
  [].slice.call(document.querySelectorAll('[data-fh-video]')).forEach(function (wrap) {
    var vid = wrap.querySelector('[data-fh-videoel]');
    var unmute = wrap.querySelector('[data-fh-unmute]');
    if (!vid) return;
    var reduceV = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduceV) { var pr = vid.play(); if (pr && pr.catch) pr.catch(function () {}); }
    if (unmute) unmute.addEventListener('click', function () {
      vid.muted = !vid.muted;
      unmute.textContent = vid.muted ? '🔇' : '🔊';
      if (!vid.muted) { var p = vid.play(); if (p && p.catch) p.catch(function () {}); }
    });
  });

  /* ---------- accordions (single-open per [data-fh-accgroup]) ---------- */
  [].slice.call(document.querySelectorAll('[data-fh-accgroup]')).forEach(function (group) {
    var items = [].slice.call(group.querySelectorAll('.fh-acc-item'));
    items.forEach(function (item) {
      var btn = item.querySelector('[data-fh-acc]');
      var body = item.querySelector('.fh-acc-body');
      if (!btn || !body) return;
      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('fh-acc-open');
        items.forEach(function (it) {
          it.classList.remove('fh-acc-open');
          var bd = it.querySelector('.fh-acc-body'); if (bd) { bd.style.maxHeight = '0px'; bd.style.opacity = '0'; }
        });
        if (!isOpen) { item.classList.add('fh-acc-open'); body.style.maxHeight = body.scrollHeight + 'px'; body.style.opacity = '1'; }
      });
    });
  });
})();
